export const SET_BOOKING_DATE = "SET_BOOKING_DATE";

export const SET_BOOKING_TIME = "SET_BOOKING_TIME";

export const UPDATE_LOGIN_MODAL = "UPDATE_LOGIN_MODAL";

export const UPDATE_BOOKING_MODAL = "UPDATE_BOOKING_MODAL";

export const UPDATE_MODAL_NUMBER = "UPDATE_MODAL_NUMBER";

export const UPDATE_CALENDER_EVENT_REQUESTED = "UPDATE_CALENDER_EVENT_REQUESTED";

export const UPDATE_CALENDER_EVENT_SUCCESS = "UPDATE_CALENDER_EVENT_SUCCESS";

export const UPDATE_CALENDER_EVENT_FAILURE = "UPDATE_CALENDER_EVENT_FAILURE";

export const FETCH_MENTOR_EVENTS_REQUESTED = "FETCH_MENTOR_EVENTS_REQUESTED";

export const FETCH_MENTOR_EVENTS_SUCCESS = "FETCH_MENTOR_EVENTS_SUCCESS";
